export const info = [
    {
        "category": "All Species",
        "description": "This category includes all the threatened species across various groups, providing a holistic view of biodiversity at risk."
    },
    {
        "category": "Mammals",
        "description": "Mammals are warm-blooded vertebrates characterized by the presence of hair or fur, and most species give live birth. Examples include tigers, elephants, and whales."
    },
    {
        "category": "Birds",
        "description": "Birds are warm-blooded, egg-laying creatures with feathers and wings, often adapted for flight. Examples include eagles, parrots, and penguins."
    },
    {
        "category": "Reptiles",
        "description": "Reptiles are cold-blooded vertebrates with scaly skin, typically laying eggs. Examples include crocodiles, turtles, and lizards."
    },
    {
        "category": "Amphibians",
        "description": "Amphibians are cold-blooded vertebrates that live both in water and on land, undergoing metamorphosis from larvae to adults. Examples include frogs, toads, and salamanders."
    },
    {
        "category": "Fishes",
        "description": "Fishes are cold-blooded aquatic vertebrates with gills and fins. Examples include sharks, tuna, and clownfish."
    },
    {
        "category": "Molluscs",
        "description": "Molluscs are soft-bodied invertebrates, often with a hard shell, including snails, clams, and octopuses."
    },
    {
        "category": "Other Inverts",
        "description": "This category includes other invertebrates like insects, arachnids, and crustaceans, which play critical roles in ecosystems."
    },
    {
        "category": "Plants",
        "description": "Plants include a wide variety of species, from flowering plants to trees, critical for oxygen production and ecological balance."
    },
    {
        "category": "Fungi",
        "description": "Fungi are a separate kingdom of organisms that include mushrooms, molds, and yeasts, essential for decomposition and nutrient cycling."
    },
    {
        "category": "Chromists",
        "description": "Chromists are a diverse group of organisms, including algae and diatoms, which are vital for aquatic ecosystems and oxygen production."
    }
];
